<template>
    <div class="expand-row">
        <div
            class="expand-row__label"
            :class="{'expand green': expand}"
            @click="toggle()"
        >
            <slot name="label">
                {{ label }}
            </slot>
            <i class="icon" :class="rightIcon" />
        </div>

        <div
            ref="expand"
            :class="[{expand: expand, hidden: !expand}]"
            class="expand-row__content"
            :style="{ height }"
        >
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: false,
            default: ''
        },
        rightIcon: {
            type: String,
            required: false,
            default: 'fa-solid fa-chevron-down'
        }
    },
    data() {
        return {
            expand: false,
            height: '0',
            timeout: null
        };
    },
    methods: {
        showBody() {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            this.height = `${this.$refs.expand.scrollHeight}px`;
            this.$nextTick(() => {
                this.timeout = setTimeout(() => {
                    this.height = '';
                }, 250);
            });
        },
        hideBody() {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            this.height = `${this.$refs.expand.scrollHeight}px`;
            this.$nextTick(() => {
                this.timeout = setTimeout(() => {
                    this.height = '0px';
                });
            }, 0);
        },
        toggle() {
            if (!this.expand) {
                this.expand = true;
                this.showBody();
            }
            else {
                this.expand = false;
                this.hideBody();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.expand-row {
    @include border(bottom);
    &:last-child {
        border: 0;
        .expand-row__content { padding-bottom: 0; }
    }

    &__label {
        @include flex(between);
        flex-wrap: nowrap;
        gap: 0.5rem;
        cursor: pointer;
        font-weight: bold;
        @include font-size(14px);
        @include spacing(padding,3,(top,bottom));
        i { 
            transition: .3s ease-in-out; 
        }
    }

    &__label.expand {
        .icon { transform: rotate(180deg) }
    }

    &__content::v-deep {
        overflow: hidden;
        transition: height 500ms ease;
        box-sizing: border-box;


        p { @include font-size(14px,8px); }
    }
    &__content.hidden {
        height: 0;
    }
}
</style>
